export default function CounterOffersRemaining({ count }) {
  return (
    <p className='remainingCounter flex alignCenter'>
      <span className='count'>{count}</span>
      <span>Counter offers remaining</span>

      <style jsx>{`
        .remainingCounter {
          width: 29rem;
          height: 4.2rem;
          margin: auto;
          padding: 0 2rem 0 0.4rem;
          border-radius: 2.5rem;
          background: #f5f6f9;

          span {
            font-size: 1.8rem;
            font-weight: 700;
          }

          .count {
            display: block;
            width: 3.4rem;
            height: 3.4rem;
            margin: 0 0.8rem 0 0;
            border-radius: 50%;
            background: var(--alert-color);
            text-align: center;
            line-height: 3.4rem;
            color: #fff;
            font-size: 1.8rem;
            font-weight: 700;
          }
        }

        @media (max-width: 1024px) {
          .remainingCounter {
            width: 20rem;
            height: 3.5rem;
            padding: 0 0.8rem;

            .count {
              width: 2.8rem;
              height: 2.8rem;
              line-height: 2.8rem;
            }

            .count,
            span {
              font-size: 1.2rem;
            }
          }
        }
      `}</style>
    </p>
  )
}
